var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{ref:"vSelect",staticClass:"w-full",attrs:{"options":_vm.statusOptions,"multiple":false,"clearable":false,"close-on-select":"","getOptionLabel":_vm.getOptionLabel},model:{value:(_vm.valueLocal),callback:function ($$v) {_vm.valueLocal=$$v},expression:"valueLocal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }